import React from "react";
import backarrow from "../../../assets/images/back-arrow-left.svg";
import closeicon from "../../../assets/images/close.svg";
import { useNavigate } from "react-router-dom";
import { screenResolution } from "../../../utils/screenResolution";
import BottomStickyBtnLayout from "../newMotorPolicy/Layouts/BottomStickyBtnLayout";
import useFileClaimFlow from "../../../hooks/useFileClaimFlow";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const FileClaimMotorLayout = ({
    children,
    is_hide_back_btn,
    show_close_btn,
    btn_label,
    btn_onClick,
    btn_disabled,
    // Held while a page has work in flight the customer must not walk out on —
    // a document still being read, whose verdict would otherwise be lost with
    // the page that asked for it.
    back_disabled,
    show_summary,
    is_bottom_sticky_layout = true,
    back_onClick,

}) => {
    const navigate = useNavigate();
    const { handlePrevSubstep } = useFileClaimFlow()
    const translate = useLanguageTranslate()
   

    // Every page in the flow renders through this layout, and each step swaps
    // in a different page component, so this wrapper is a fresh element on
    // every advance and the one-shot entrance plays without needing a key.
    //
    // It wraps the page content only. The sticky footer is a sibling rendered
    // by BottomStickyBtnLayout and the back button sits outside it, both on
    // purpose: fading an ancestor would fade the footer with it, and a
    // transform on an ancestor makes it the containing block for anything
    // `position: fixed` underneath — which would tear the footer off the
    // viewport mid-transition.
    const stepAnimationClass = "animate-claimStepIn";

    return (
        <div className="">
            {/* On mobile the Back button stays reachable while the step
                scrolls. The popup scrolls inside .mainCarDetailsModal, not the
                window, so the button sits in a zero-height sticky strip inside
                that scroller: it starts where it always did, and once the page
                has scrolled 36px it stays pinned 12px from the top. The strip
                sits below the scroller's pt-[5%] (5vw on a phone, where the
                popup is full width), so the button's own mobile offset
                subtracts it to start exactly where it used to (3rem from the
                top). A sticky `top` is measured inside the scroller's padding,
                so the -36px needs no correction for it. The strip is h-0 and
                has no margin, so the step below doesn't move. Desktop is
                untouched: the strip is static there. */}
            {!is_hide_back_btn && (
                <div className="max767:sticky max767:top-[-36px] max767:z-20 max767:h-0">
                    <button
                        className="backButton bg-navy-blue py-2 rounded mt-20 flex absolute left-[26px] top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px] max767:bg-[#F6F8F9] max767:w-10 max767:h-10 max767:text-center max767:justify-center max767:rounded-3xl max767:mt-[calc(3rem-5vw)] max767:ml-[-11px] max767:shadow-[0_1px_2px_rgba(26,32,36,0.08),0_2px_8px_rgba(26,32,36,0.08)] max767:transition-transform max767:duration-150 max767:ease-out max767:active:scale-[0.94] rtl:right-[26px] disabled:opacity-40 disabled:cursor-not-allowed"
                        disabled={back_disabled}
                        onClick={back_onClick || handlePrevSubstep}
                    >
                        <img src={backarrow} alt="Back arrow" className="1 rtl:rotate-180" />
                        <span className="back-text inline max767:hidden">{translate("Back","رجوع")}</span>
                    </button>
                </div>
            )}
            {false && show_close_btn && screenResolution.mobile && (
                <button
                    className="bpy-2 rounded mt-4 flex absolute top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px] max767:ml-0"
                    onClick={() => navigate('/file-a-claim')}
                >
                    <img src={closeicon} alt="Close Icon" />
                </button>
            )}
            {is_bottom_sticky_layout ?
                <BottomStickyBtnLayout show_summary={show_summary} btn_onClick={btn_onClick} btn_disabled={btn_disabled} btn_label={btn_label}>
                    <div data-claim-step className={`${stepAnimationClass} ${(!is_hide_back_btn || show_close_btn) ? "max767:pt-16" : ""}`}>
                        {children}
                    </div>
                </BottomStickyBtnLayout> :
                <div data-claim-step className={`${stepAnimationClass} ${(!is_hide_back_btn || show_close_btn) ? "max767:pt-16" : ""}`}>
                    {children}
                </div> }

        </div>
    );
};

export default FileClaimMotorLayout;
